<template>
  <div class="product-selector">
    <div class="base-sim select-options" v-if="builder || viewAll">
      <vue-toggle :options="baseOptions" :selected.sync="selection.deal" class="row no-gutters">
        <template slot-scope="{item}">
          <div class="col col-sm-6 col-md-3 col-xl-3">
            <button
              class="btn sim row no-gutters"
              v-on:click="selection.deal = selection.deal != item ? item : null"
              v-bind:class="['btn', { 'active-deal': selection.deal != null && selection.deal.id === item.id }]"
            >
              <div class="col-12 sim-heading">
                <div class="sim-corner"></div>
                <h1>{{ item.display_details.name }}</h1>
                <span class="price">{{ item.price | currency }}</span>
              </div>
              <div class="col-12 deal-items" v-html="item.display_details.description"></div>
            </button>
          </div>
        </template>
      </vue-toggle>
    </div>

    <div class="deals select-options" v-if="!builder || viewAll">
      <vue-toggle :options="dealOptions" :selected.sync="selection.deal" class="row no-gutters">
        <template slot-scope="{item}">
          <div class="col col-sm-6 col-md-3 col-xl-3">
            <button
              class="btn sim row no-gutters"
              v-on:click="selection.deal = selection.deal != item ? item : null"
              v-bind:class="['btn', { 'active-deal': selection.deal != null && selection.deal.id === item.id }]"
            >
              <div class="col-12 sim-heading">
                <div class="sim-corner"></div>
                <h1>{{ item.display_details.name }}</h1>
                <span class="price">{{ item.price | currency }}</span>
              </div>
              <div class="col-12 deal-items" v-html="item.display_details.description"></div>
            </button>
          </div>
        </template>
      </vue-toggle>
    </div>

    <div class="deal-addons" v-if="allowAddons">
      <div class="data select-options" v-if="validSelection && options.recurring.data.length > 0">
        <label id="data-label">Add Monthly Data</label>
        <vue-toggle
          :options="options.recurring.data"
          :selected.sync="selection.data"
          class="row no-gutters"
        >
          <template slot-scope="{item}">
            <div class="col">
              <button
                type="button"
                class="btn btn-default"
                v-on:click="selection.data = selection.data != item ? item : null"
                v-bind:class="['btn', selection.data != null && selection.data.id === item.id ? 'btn-primary': 'btn-dark']"
              >
                <span class="name">{{ item.name }}</span>
                <span>{{ item.price | currency }}</span>
              </button>
            </div>
          </template>
        </vue-toggle>
      </div>

      <div class="mins select-options" v-if="validSelection && options.recurring.mins.length > 0">
        <label id="mins-label">Add Monthly Mins</label>
        <vue-toggle
          :options="options.recurring.mins"
          :selected.sync="selection.mins"
          class="row no-gutters"
        >
          <template slot-scope="{item}">
            <div class="col">
              <button
                type="button"
                class="btn btn-default"
                v-on:click="selection.mins = selection.mins != item ? item : null"
                v-bind:class="['btn', selection.mins != null && selection.mins.id === item.id ? 'btn-primary': 'btn-dark']"
              >
                <span class="name">{{ item.name }}</span>
                <span>{{ item.price | currency }}</span>
              </button>
            </div>
          </template>
        </vue-toggle>
      </div>

      <div class="sms select-options" v-if="validSelection && options.recurring.sms.length > 0">
        <label id="sms-label">Add Monthly SMS's</label>
        <vue-toggle
          :options="options.recurring.sms"
          :selected.sync="selection.sms"
          class="row no-gutters"
        >
          <template slot-scope="{item}">
            <div class="col">
              <button
                type="button"
                class="btn btn-default"
                v-on:click="selection.sms = selection.sms != item ? item : null"
                v-bind:class="['btn', selection.sms != null && selection.sms.id === item.id ? 'btn-primary': 'btn-dark']"
              >
                <span class="name">{{ item.name }}</span>
                <span>{{ item.price | currency }}</span>
              </button>
            </div>
          </template>
        </vue-toggle>
      </div>

      <div
        class="whatsApp select-options"
        v-if="validSelection && options.recurring.whatsApp.length > 0"
      >
        <label id="whatsApp-label">Add Monthly WhatsApp</label>
        <vue-toggle
          :options="options.recurring.whatsApp"
          :selected.sync="selection.whatsApp"
          class="row no-gutters"
        >
          <template slot-scope="{item}">
            <div class="col">
              <button
                type="button"
                class="btn btn-default"
                v-on:click="selection.whatsApp = selection.whatsApp != item ? item : null"
                v-bind:class="['btn', selection.whatsApp != null && selection.whatsApp.id === item.id ? 'btn-primary': 'btn-dark']"
              >
                <span class="name">{{ item.name }}</span>
                <span>{{ item.price | currency }}</span>
              </button>
            </div>
          </template>
        </vue-toggle>
      </div>
    </div>

    <div class="no-deal-selected" v-if="!validSelection">Please select a deal above.</div>
  </div>
</template>

<script>
import EventBus from "@/components/shared/event-bus";
import store from "@/store";
import SimModel from "@/models/sim.model";
import {
  CART_UPDATE_CURRENT_ITEM,
  CART_RESET_CURRENT_ITEM
} from "@/store/actions.type";

export default {
  name: "vue-product-selector",
  props: ["builder", "viewAll", "sim", "callCentre", "product_type", "allowAddons"],
  data: function() {
    return {
      current_step: store.state.cart.current_step,
      selection: this.sim,
      type: this.product_type
    };
  },
  computed: {
    baseOptions() {
      var self = this;
      var options = [];
      self.options.recurring.base.forEach(element => {
          if(self.callCentre) {
            if(element.is_special) options.push(element)
          } else {
            if(element.is_show) options.push(element);
          }
      });
      return options;
    },
    dealOptions() {
      var self = this;
      var options = [];      
      self.options.recurring.deal.forEach(element => {        
        if (self.product_type == element.product_type) {
          if(self.callCentre) {
            if(element.is_special) options.push(element)
          } else {
            console.log(element);
            if(element.is_show) options.push(element);
          }
        }
      });
      return options;
    },
    options() {
      return store.state.products.products.options;
    },
    isLoading() {
      return store.state.products.is_loading;
    },
    validSelection() {
      return !this.isEmpty(store.state.cart.current_sim.deal);
    }
  },
  watch: {
    selection: {
      handler(value) {
        var self = this;
        if (!self.isLoading) {
          self.$log.debug("PRODUCT SELECTOR SIM CHANGE", value);
          store.dispatch(CART_UPDATE_CURRENT_ITEM, value);
          EventBus.$emit("product_selected", store.state.cart.current_sim.deal);
        }
      },
      deep: true
    }
  },
  methods: {
    isEmpty: function(data) {
      return (
        data == null ||
        typeof data == "undefined" ||
        Object.keys(data).length === 0
      );
    },
    initSim() {
      var self = this;
      if (self.builder) {
        self.selection.deal = self.options.recurring.base[0];
      }
      self.selection.product_type = self.product_type;
    },
    registerListeners() {
      var self = this;
      EventBus.$on("clear:current-item", function() {
        self.selection = new SimModel();
        store.dispatch(CART_RESET_CURRENT_ITEM);
      });
    }
  },
  mounted() {
    var self = this;
    self.registerListeners();
    self.initSim();    
  }
};
</script>



